import type { GetAdCopyReportOutlineResBody } from "../../../../../../server/types/request/ad-copy/report/outline";
import type { AdCopyOutlineAction } from "../../../../types/actions";
import type { MessageInfo } from "../../../../types/info";

type State = Partial<GetAdCopyReportOutlineResBody> & {
	info: MessageInfo;
	loading: boolean;
};

export const initState: State = {
	info: {
		isSuccess: true,
		message: "",
	},
	loading: true,
};

export const reducer = (state: State, action: AdCopyOutlineAction): State => {
	switch (action.type) {
		case "loadData":
			return {
				...state,
				loading: false,
				...action.payload,
			};

		case "changeMessageInfo":
			return {
				...state,
				info: action.payload,
				loading: false,
			};

		case "changeLoading":
			return {
				...state,
				loading: action.payload,
			};
	}
};
